import classNames from "classnames";
import React from "react";
import { default as CashIcon } from "../../../public/assets/cash.svg?react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { CHAT_ICON, PATIENTS_ICON, TRAINING_ICON, VISITS_ICON } from "../../utils/svgs_new";
import { AppIcon } from "../Generic/AppIcon";
import IconWithBadge from "../IconWithBadge/IconWithBadge";
import { MainScreenTab } from "./MainTypes";

interface Props {
  activeTab: MainScreenTab;
  totalNewChats: number;
  totalNewVideos: number;
  isCaregiverOfMedflyt: boolean;
  isInstapayVisible: boolean;
  onClickInstaPay: () => void;
  onClickVisits: () => void;
  onClickTraining: () => void;
  onClickPatients: () => void;
  onClickChat: () => void;
}

const ScaffoldNavFooter = (props: Props) => {
  const iconsSize = 22;

  return (
    <div className="ScaffoldNavFooter">
      <div
        onClick={props.onClickVisits}
        className={classNames({ active: props.activeTab === "Visits" })}
      >
        <AppIcon icon={VISITS_ICON} size={iconsSize} />
        <span>{translate(STRINGS.VISITS)}</span>
      </div>

      <div
        onClick={props.onClickTraining}
        className={classNames({ active: props.activeTab === "TrainingCenter" })}
      >
        <IconWithBadge icon={TRAINING_ICON} badge={props.totalNewVideos} size={iconsSize} />
        <span>{translate(STRINGS.TRAINING)}</span>
      </div>

      {props.isInstapayVisible ? (
        <div onClick={props.onClickInstaPay}>
          <AppIcon icon={<CashIcon />} size={iconsSize} />
          <span>{translate(STRINGS.INSTAPAY)}</span>
        </div>
      ) : null}

      <div
        onClick={props.onClickPatients}
        className={classNames({ active: props.activeTab === "Patients" })}
      >
        <AppIcon icon={PATIENTS_ICON} size={iconsSize} />
        <span>{translate(STRINGS.PATIENTS)}</span>
      </div>

      <div
        onClick={props.onClickChat}
        className={classNames({ active: props.activeTab === "Chat" })}
      >
        <IconWithBadge icon={CHAT_ICON} badge={props.totalNewChats} size={iconsSize} />
        <span>{translate(STRINGS.CHAT)}</span>
      </div>
    </div>
  );
};

export default ScaffoldNavFooter;
